import * as React from "react";
const SvgFiBrandsDiscord = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#151A2D"
      d="M20.317 4.37a19.8 19.8 0 0 0-4.885-1.515.08.08 0 0 0-.079.037c-.21.375-.445.865-.608 1.249a18.3 18.3 0 0 0-5.487 0 13 13 0 0 0-.617-1.25.08.08 0 0 0-.079-.036A19.7 19.7 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.535 9.045-.319 13.579.1 18.057a.08.08 0 0 0 .031.056 19.9 19.9 0 0 0 5.993 3.029.08.08 0 0 0 .084-.028q.695-.945 1.226-1.994a.076.076 0 0 0-.042-.106 13 13 0 0 1-1.872-.892.078.078 0 0 1-.008-.128 10 10 0 0 0 .372-.291.07.07 0 0 1 .078-.01c3.928 1.793 8.18 1.793 12.061 0a.07.07 0 0 1 .08.01q.18.15.372.292c.044.032.041.1-.007.128-.598.349-1.219.645-1.873.89a.077.077 0 0 0-.04.108c.36.698.771 1.363 1.224 1.993a.08.08 0 0 0 .084.029 19.9 19.9 0 0 0 6.002-3.03.08.08 0 0 0 .031-.054c.5-5.177-.838-9.674-3.548-13.66a.05.05 0 0 0-.03-.03M8.02 15.33c-1.183 0-2.157-1.085-2.157-2.418s.955-2.42 2.157-2.42c1.211 0 2.176 1.096 2.157 2.42 0 1.334-.956 2.419-2.157 2.419m7.975 0c-1.182 0-2.157-1.085-2.157-2.418s.955-2.42 2.157-2.42c1.211 0 2.176 1.096 2.157 2.42 0 1.334-.946 2.419-2.157 2.419"
    />
  </svg>
);
export default SvgFiBrandsDiscord;
